import React from 'react'

const PageNotFound = () => {
  return (
    <div>404 PageNotFound!</div>
  )
}

export default PageNotFound